import {Component, Input, ViewChild} from '@angular/core'
import { IDataCardWorkOrder, IDataCardWorkPermit } from "../../../../../../models/data-card.model"
import { NzDrawerService } from "ng-zorro-antd/drawer"
import {
  MainObjectDataCardTemplateComponent
} from "../../../main-object-data-card-template/main-object-data-card-template.component"
import {NgbNav} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-data-work-order-permit',
  standalone: false,
  templateUrl: './data-work-order-permit.component.html',
  styleUrl: './data-work-order-permit.component.scss',
})
export class DataWorkOrderPermitComponent {
  @ViewChild('nav') private nav: NgbNav

  @Input() data: IDataCardWorkOrder
  @Input() isLoading: boolean = false

  public constructor(private drawerService: NzDrawerService) {}

  public onDataCardDrawerOpen(mainObject: string): void {
    this.drawerService.create<MainObjectDataCardTemplateComponent, { mo: string }, any>({
      nzTitle: 'Datacard',
      nzWidth: '500px',
      nzContent: MainObjectDataCardTemplateComponent,
      nzData: { mo: mainObject },
    })
  }

  public hasWorkPermit(): boolean {
    return this.data?.work_permits != null && this.data?.work_permits.length > 0
  }

  public getFirstWorkPermit(): IDataCardWorkPermit {
    return this.hasWorkPermit() ? this.data?.work_permits[0] : null
  }
}
